import React from 'react';
import './blog-post.css';

//import reportWebVitals from './reportWebVitals';

const RebrandSurvey2022 = () => {

  return (
    <div>
      <div className='blog__container'>
        <div className="row">
            <div className="column">
                <header>
                    <h3 className="site-post-title rounded title-padding">
                        <b>WiC at Work</b>
                    </h3>
                </header>
                <section>
                    <h2>Fill Out The Rebranding Survey</h2>
                    <p class="site-post-meta">June 23, 2022</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                        Hi CSE!
                    </p>
                    <p>
                        Hope you are having a great summer!
                    </p>
                    <p>
                        ACM-W is rebranding and will no longer be affiliated with the larger ACM organization.
                        We are interested in hearing input from Allen School students and ACM-W members as we
                        decide on a new name for our student group. Fill out this quick survey by Friday, July
                        1st to let us know your thoughts!
                    </p>
                    <p>
                        Fill out the survey here: <a href = "https://tinyurl.com/rebranding22">https://tinyurl.com/rebranding22</a>
                    </p>
                    <p>
                        Best,<br></br>
                        ACM-W
                    </p>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default RebrandSurvey2022;